import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=708a726e&scoped=true&"
import script from "./TagsView.vue?vue&type=script&lang=js&"
export * from "./TagsView.vue?vue&type=script&lang=js&"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=708a726e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a726e",
  null
  
)

export default component.exports